const { activeEnv } = require('./active-environment');

/**
 * Whether Prismic preview UI + gatsby-plugin-prismic-previews should run.
 * Only the test environment (`GATSBY_ACTIVE_ENV=test`), e.g. `npm run ga-test-build` and
 * the symmetrytest-style deploy — not `gatsby develop` or production.
 * Same `activeEnv` as `gatsby-config.js` (`GATSBY_ACTIVE_ENV || NODE_ENV || development`).
 */
function isPrismicPreviewEnabled() {
    return activeEnv === 'test';
}

/** Same rule as {@link isPrismicPreviewEnabled}, for callers that already computed `activeEnv`. */
function isPrismicPreviewEnabledForEnv(env) {
    return env === 'test';
}

module.exports = {
    isPrismicPreviewEnabled,
    isPrismicPreviewEnabledForEnv,
};
